import React, {FunctionComponent, useContext} from 'react';
import styled from 'styled-components';

import {Time, Container} from './ui';
import {MessageContext} from '../../utils/message';

export type PublishDateProps = {
    publishedTime: string;
    formattedPublishedTime: string;
    isUpdated: boolean;
};

const RawPublishDate: FunctionComponent<PublishDateProps> = ({publishedTime, isUpdated, formattedPublishedTime}) => {
    const {getText} = useContext(MessageContext);
    const translationType = isUpdated ? 'updated' : 'published';

    return (
        <Container>
            <span>{getText(`publish-date.${translationType}`)}</span>
            <Time dateTime={publishedTime}>{formattedPublishedTime}</Time>
        </Container>
    );
};

export const PublishDate = styled(RawPublishDate)``;
